import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=e836219c&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e836219c')) {
      api.createRecord('e836219c', component.options)
    } else {
      api.reload('e836219c', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=e836219c&", function () {
      api.rerender('e836219c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2yPugGVzlGShS/JS/childrenage.vue"
export default component.exports